import { Injectable } from '@angular/core';
import { CustomAjax } from '../AjaxHelper';
import { MemberSurvey } from '../AllTableClasses';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(private ajax: CustomAjax) { }


  public MemberSurveyGet(GeneratedGuid: string, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetJSONData("/Survey/MemberSurveyGet", `GeneratedGuid=${GeneratedGuid}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public MemberSurveyAnswersSet(survey: MemberSurvey, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Survey/MemberSurveyAnswersSet", survey,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

}
